export const PINNED_FIELDS_BANNER_PREFERENCE_KEY =
	'jira.user.issue.pinned-fields-banner.lastinteracted' as const;
export const PINNED_FIELDS_BANNER_USER_HIDDEN_ACTION =
	'jira.user.issue.pinned-fields-banner.user_hidden_action' as const;
export const PINNED_FIELDS_BANNER_DISMISS_ACTION =
	'pinnedFieldsBannerDismissSectionMessage' as const;
export const NUMBER_OF_DAYS_TO_SHOW = 7;
